// extracted by mini-css-extract-plugin
module.exports =  {"columns":"gnKqsJ7zYB05hpCO6tcI","content":"rgUqY_H6oIWJzC8wFOoE"};